module.exports = __webpack_public_path__ + "static/media/1.3.ee61c267.jpg";